<template style='text-align:left'>

    <v-layout row >
      <!-- v-flex xs12 mx-2>
        <div style='float:left;margin-right:1em;width:6em'><span v-html='date()'></span></div>
        <div style='float:left;width:80%'>
          <b v-html='heading()'></b>
          <span v-html='detail()'></span>
        </div>        
      </v-flex -->   

      <v-flex xs12 mx-0>
        <div style='float:left;margin-right:1em;width:8.5em;text-align:left;xxfont-family:fixed'><span v-html='date()'></span></div>
        <div v-if="steps" style='float:left;width:80%'> <!-- v-if added 15aug19 -->
          <b v-html='heading()'></b>
          <span  v-for="(step, index) in steps.slice(1)" v-bind:key="index">
            <span v-if="conditionalPrefix[index]">{{conditionalPrefix[index]}}</span>
            <span v-if="step.type === 's'">{{step.s}}</span>
            <span v-else-if="step.type === ':'"></span>            
            <span v-else-if="step.type === 'd' && bio[step.prop]"> {{$dateFormatFromYMD(bio[step.prop])}}</span>
            <span v-else-if="step.type === 't' && bio[step.prop]"> {{$dateTimeFormatFromYMDTHM(bio[step.prop])}}</span>
            <!-- span v-else-if="step.type === 'c' && bio[step.fld]" -->
            <router-link  v-else-if="step.type === 'c' && bio[step.fld]"
              :to="{path: '/people?relType=' + step.code + '&relValue=' + bio[step.fld].id + '&description=' + bio[step.fld].v}">
              {{ bio[step.fld].v}}
            </router-link>
            <!-- /span -->
            <place-summary v-else-if="step.type === 'p' && bio[step.prop]" v-bind:place="bio[step.prop]"></place-summary>
            <rank-with-link v-else-if="step.type === 'r' && bio[step.prop]" v-bind:field="bio[step.prop]"></rank-with-link>
            <item-with-link v-else-if="step.type === 'u' && bio[step.prop]" v-bind:field="bio[step.prop]" v-bind:fieldName="'unit'"></item-with-link>            
            <span v-else-if="step.type === 'x' && bio[step.prop]">
              <span v-if="step.prompt">{{step.prompt}}:</span> {{bio[step.prop][step.fld]}}
            </span>
            <span v-else-if="step.type === 'y' && bio.serviceDays">
               <span v-if="step.prompt">{{step.prompt}}:</span> {{formatLengthOfService(bio.serviceDays)}}
            </span>                   
            <!--            <span v-else> XCant show {{JSON.stringify(step)}} yet</span> -->
           
          </span>
          <!-- span>type0 {{steps[0].type}} s {{steps[0].s}} {{ person.birthDate}} steps 0= {{JSON.stringify(steps[0])}} bio={{JSON.stringify(bio.date)}} </span-->
          <span v-if="steps[0] && (steps[0].type === 's') && (steps[0].s === 'Enlisted '  && bio.date && person.birthDate)"
            v-html='showAgeAtEnlistment(person.birthDate, bio.date)' style='padding-left:2em'></span>

          <div v-if="bio.note">Note: {{bio.note}}</div>
        </div>
      </v-flex>

    </v-layout> 
</template>        

<script>

export default {

  components: { },
  props: {
    bio: null,
    person: null
  },

  data () {
    return {
      steps: null,
      conditionalPrefix: []

    }
  },

  async created () {

    console.log("In showbio created, bio prop is " + JSON.stringify(this.bio)) ;
    this.steps = this.$constants.decodedBioEntries[this.bio.beTemplateId] ;

    let changeConditionalPrefixFrom = null ;

    if (this.bio.dt1) {
      if (!this.bio.dt2) {  // no "to"
        if ((this.bio.dt1.length === 10) || // just a date, no time..
          this.bio.dt1.endsWith("T00:00")) changeConditionalPrefixFrom = "on" ;
        else changeConditionalPrefixFrom = "at" ;
      }
    }
    console.log("changeConditionalPrefixFrom: " + changeConditionalPrefixFrom + " STEPS :" + JSON.stringify(this.steps)) ;  
    if (this.steps) { // 15aug19
      this.conditionalPrefix = new Array(this.steps.length) ;
      for (let i = 1; i < (this.steps.length - 1); i++) {
        const step = this.steps[i] ;
        if (step.type === ':') {  // conditional prefix!  set if NEXT step value is present
          const nextStep = this.steps[i + 1] ;
          if (this.bio[nextStep.prop] || this.bio[nextStep.fld]) {
            if (changeConditionalPrefixFrom && (step.conditionalPrefix === 'from')) this.conditionalPrefix[i] = changeConditionalPrefixFrom ;  // 15jul20
            else this.conditionalPrefix[i] = step.conditionalPrefix ; // NB those cond prefix are BASE 1!
          }
        }
      } 
      console.log("SET conditionalPrefix to " + JSON.stringify(this.conditionalPrefix)) ;
    }

  },
  async mounted () {

  },

  methods: {

    date () {
      if (!this.bio.date) return "<span class='lite'>undated&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>" ;
      return this.$dateFormatFromYMD(this.bio.date).replace(/ - /, "<BR/>  - ").replace(/ /g, "&nbsp;") ;       
    },

    heading () {
      if (!this.steps || (this.steps.length < 1)) return "Unknown" ;
     
      const step1 = this.steps[0] ;
      if (step1.type !== 's') return "" ;
      return step1.s ;
    },

    showAgeAtEnlistment (birthDate, enlistmentDate) {

      try {
        let from = this.$moment(birthDate) ;
        let to = this.$moment(enlistmentDate) ;
        let diff = to.diff(from) ;
        let duration = this.$moment.duration(diff) ;
        let months = duration.months() ;
        var s = " Age at enlistment: " + duration.years() + " years " ;
        if (months > 0)  s += " and " + months + " month" + ((months > 1) ? "s" : "") ;
        return s ;
      }
      catch (ex) {
        console.log("enlist age error " + ex + " from " + birthDate + " to " + enlistmentDate) ;
      }
      //   console.log("FROM MOMENT =" + from +  " TO=" + to + " DIFF " + diff + " DURATION " + duration.months()) ;
      // return " CALC AGE from " + birthDate + " to " + enlistmentDate  + "moment " +
      //   this.$moment(birthDate + " - 1221-22-12", "YYYY-MM-DD").format("Do MMMM YYYY") 
    },

    formatLengthOfService (totalDays) {

      const years = Math.floor(totalDays / 365) ;
      const days = totalDays - (years * 365) ;
      let s = "" ;
      if (years > 0) s = "" + years + ((years > 1) ? " years" : " year") ;
      if (days > 0) {
        if (s) s += " and " ;
        s += "" + days + ((days > 1) ? " days" : " day") ;
      }
      return s ;
    }

    /* replaced with template code

    addConditionalPrefixAndValue (conditionalPrefix, value) {
      if (conditionalPrefix) return " " + conditionalPrefix + " " + value ;
      else return " " + value ;
    },

    detail () {
      let s = "" ;
      let deb = " DEBUG: "
      console.log("showbio detail in, steps=" + JSON.stringify(this.steps) + " bio=" + JSON.stringify(this.bio)) ;
      let conditionalPrefix = null ;  // a pending prefix to be shown if non null, and cleared at the end of each step

      if (this.steps) {
        for (let i = 0; i < this.steps.length; i++) {
          const step = this.steps[i] ;
          if ((i === 0) && (step.type === 's')) continue ;
          deb += " " + JSON.stringify(step) ;
          let nextConditionalPrefix = null ;
          switch (step.type) {
            case 's':        // constant string
              s += this.addConditionalPrefixAndValue(conditionalPrefix, step.s) ;
              break ;

            case 'c':       // coded value
              let fld = this.bio[step.fld] ;
              console.log("show code  fld " + step.fld) ;
              if (!fld) break ;
              s += this.addConditionalPrefixAndValue(conditionalPrefix, "<a href='8080/people?relType=" + step.code + "&relValue=" + fld.id + "&description=" + fld.v + "'>" + fld.v + "</a>") ;
              break ;

            case 'd':     // date
              let val = this.bio[step.prop] ;
              if (val) s += this.addConditionalPrefixAndValue(conditionalPrefix, this.$dateFormatFromYMD(val)) ;
              break ;

            case 't':     // date time
              val = this.bio[step.prop] ;
              if (val) s += this.addConditionalPrefixAndValue(conditionalPrefix, this.$dateTimeFormatFromYMDTHM(val)) ;
              break ;

            case 'p':     // place
              let place = this.bio[step.prop] ;
              if (place) s += this.addConditionalPrefixAndValue(conditionalPrefix, this.$placeSummary(place)) ;
              break ;

            case 'r':     // rank
              let rank = this.bio[step.prop] ;
              if (rank) s += this.addConditionalPrefixAndValue(conditionalPrefix, this.$renderStandardListWithLink(rank, 'rank')) ;
              break ;            

            case 'u':     // unit
              let unit = this.bio[step.prop] ;
              if (unit) s += this.addConditionalPrefixAndValue(conditionalPrefix, this.$renderStandardListWithLink(unit, 'unit')) ;
              break ;   

            case 'x':     // text
              let txtProp = this.bio[step.prop] ;
              if (txtProp) s += this.addConditionalPrefixAndValue(conditionalPrefix, ((step.prompt) ? (step.prompt + ": ") : "") + txtProp[step.fld]) ;
              break ; 
              
            case ':':   // conditional prefix - show if next step isnt empty
              nextConditionalPrefix = step.conditionalPrefix ; 
              break ;

            default:
              s += "Unrecognised type in step " + JSON.stringify(step) ;
              break ;
          }
          conditionalPrefix = nextConditionalPrefix ;
        }
      }
      if (this.bio.note) s += "<BR/> Note: " + this.bio.note ;
      console.log("showbio detail out, steps=" + JSON.stringify(this.steps) + " // debug: " + deb) ;
      return s ; // "<BR/>" + deb ;
    }
    */
  } 
}
</script>

<style>
.lite {color:#aaaaaa} ;
</style>



// WEBPACK FOOTER //
// src/components/Person/ShowBio.vue